import { DatabaseRecord } from "@/core/repos/table.repo";
import { ReportTable, ReportTableConfigs } from "../../components/report/ReportTable";
import { Suspense, useState } from "react";
import { ConfigProvider, Select } from "antd";
import { MODAL_THEME } from "@/core/themes/modal.theme";
import { WATER_INDEX_REPORT_CONFIGS } from "./configs/water-index-report";
import { HIGH_CONSUMPTION_REPORT_CONFIGS } from "./configs/high-consumption-report";
import { UNREAD_INDEX_REPORT_CONFIGS } from "./configs/unread-index-report";
import { ABNORMAL_CONSUMPTION_REPORT_CONFIGS } from "./configs/abnormal-consumption-report";
import { INDEX_BETWEEN_REPORT_CONFIGS } from "./configs/index-between-report";
import { NO_CONSUMPTION_REPORT_CONFIGS } from "./configs/no-consumption-report";
import { useSearchParams } from "react-router";

function IndexReport() {
    const reportConfigs: {name: string, props: ReportTableConfigs<any, any>}[] = [
        WATER_INDEX_REPORT_CONFIGS,
        UNREAD_INDEX_REPORT_CONFIGS,
        HIGH_CONSUMPTION_REPORT_CONFIGS,
        ABNORMAL_CONSUMPTION_REPORT_CONFIGS,
        INDEX_BETWEEN_REPORT_CONFIGS,
        NO_CONSUMPTION_REPORT_CONFIGS
    ]
    const [searchParams] = useSearchParams();
    const reportIndexParam = searchParams.get('type');
    const getParamIndex = () => {
        let index = 0;
        if (!reportIndexParam) return 0;
        try {
            index = parseInt(reportIndexParam);
            if (index > reportConfigs.length - 1) index = reportConfigs.length - 1;
        } catch (err) {} 
        return index;
    }
    const [reportProps, setReportProps] = useState<ReportTableConfigs<DatabaseRecord, any>|null>(reportConfigs[getParamIndex()].props);
    const [reportIndex, setReportIndex] = useState(getParamIndex());
    const onReportSelect = (index: number) => {
        setReportIndex(index);
        setReportProps(reportConfigs[index].props);
    }

    return <div>
        <ConfigProvider theme={MODAL_THEME}>
            <div className="mx-4 mt-6">
                <p className="mb-2 text-[16px] font-[400]">Chọn loại báo cáo:</p>
                <Select className="w-full" value={reportIndex} onChange={onReportSelect}>
                    {reportConfigs.map((report, i) => (
                        <Select.Option key={report.name} value={i}>{report.name}</Select.Option>
                    ))}
                </Select>
            </div>
        </ConfigProvider>
        {reportProps!=undefined
            ?<ReportTable
                reportIndex={reportIndex}
                config={reportProps}
                />
            :null}
    </div>
}


export default function IndexReportPage() {
    return <Suspense>
        <IndexReport />
    </Suspense>
}